<script>
import { mapState } from 'vuex';

export default {
  name: 'MainDrawer',
  data() {

    return {
      odemeTalep: ' ',
      satinAlma: ' ',
      malzemeOnay: ' ',
      personelIzin: ' ',
      personelTalep: ' ',
      adayTespit: ' ',
      personelSevk: ' ',
      rapor: ''
    }},
  computed: {
    ...mapState('app', ['drawerVisible']),
    ...mapState({
      isHaveReportRight: state => state.isHaveReportRight,
      isHaveReportRightINS: state => state.isHaveReportRightINS,
      canAddUser: state => state.canAddUser,
      isHaveConfirmRight: state => state.isHaveConfirmRight,
      isKysUser: state => state.isKysUser,
      isKysAdmin: state => state.isKysAdmin,
      isRoot: state => state.isRoot,
      userEmail: state => state.userEmail
    }),
  },
  created() {
    this.$bus.$on('change-name', this.changeName);
  },
  beforeDestroy() {
    this.$bus.$off('change-name');
  },
  methods: {
    changeName(summary) {
      this.odemeTalep = summary.odemeTalep;
      this.satinAlma = summary.satinAlma;
      this.malzemeOnay = summary.malzemeOnay;
      this.personelIzin = summary.personelIzin;
      this.personelTalep = summary.personelTalep;
      this.adayTespit = summary.adayTespit;
      this.personelSevk = summary.personelSevk;
    },
    mobileMenuClick(){
      const isMobile = ()=>{
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }

      if(isMobile()){
        this.$store.commit('app/toggleDrawer')
      }
    }
  },
};
</script>

<template>
  <v-navigation-drawer :value="drawerVisible"
                       hide-overlay
                       app
                       style="background: #3E4E68;"
                       stateless
                       clipped
                       fixed
  >
    <v-list dark dense>
      <v-list-item to="/odemeTalep" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                ÖDEME TALEP
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ odemeTalep }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/satinAlmaOdemeTalep" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                SATIN A. ÖDEME TALEP
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ satinAlma }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/malzemeOnay" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                MALZEME ONAY
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ malzemeOnay }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/personelIzin" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                PERSONEL İZİN ONAY
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ personelIzin }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/personelTalepOnay" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                PERSONEL TALEP ONAYI
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ personelTalep }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/adayTespitOnay" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                ADAY TESPİT ONAYI
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ adayTespit }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/personelSevkOnay" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                PERSONEL SEVK ONAYI
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ personelSevk }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/rapor" @click="mobileMenuClick()" v-if="isHaveReportRight || isHaveReportRightINS">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                RAPORLAR
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
          <v-col>
            <v-list-item-content>
              <v-list-item-title class="align-right">
                {{ rapor }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/kullanicilar" @click="mobileMenuClick()"  v-if="canAddUser">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                KULLANICILAR
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/kysFormu" @click="mobileMenuClick()"  v-if="isKysUser">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('menuKYSTitle') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>
      
      <v-list-item to="/kycFormu" @click="mobileMenuClick()"  v-if="isKysUser">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('menuKYCTitle') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/kyeFormu" @click="mobileMenuClick()"  v-if="isKysUser">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('menuKYETitle') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>

      <v-list-item to="/mrfOnay" @click="mobileMenuClick()" v-if="isHaveConfirmRight">
        <v-row>
          <v-col cols="auto">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('menuMrfOnay') }}
                <v-chip x-small color="orange" dark class="ml-2 new-badge">YENİ</v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>
      
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss">

  .v-list-title {
    height: 50px !important;
  }

  .v-navigation-drawer a.v-list__tile {
    color: #fff;

    &.v-list__tile--active {
      color: #fff !important;
      background: #0288D1 !important;
    }

    &:hover {
      background: #0288D1 !important;
    }

    &:before {
      color: #fff;
    }

    .v-icon {
      color: #fff !important;
    }
  }

  .align-right {
    display: inline-block;
    text-align: right;
  }

  .new-badge {
    font-size: 9px !important;
    height: 16px !important;
    padding: 0 6px !important;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }
</style>
